// This array defines which "componentId" maps to which lazy-loaded module.

import { DynamicComponentManifest } from '@streamamg/components-lib';

export const dynamicComponentManifests: DynamicComponentManifest[] = [

  // Templates
  {
    componentId: 'home',
    path: 'home', // some globally-unique identifier, used internally by the router
    loadChildren: () => import('./templates/home-template/home-template.module').then(m => m.HomeTemplateModule),
  },
  {
    componentId: 'archive',
    path: 'archive', // some globally-unique identifier, used internally by the router
    loadChildren: () => import('./templates/archive-template/archive-template.module').then(m => m.ArchiveTemplateModule),
  },
  {
    componentId: 'cloud-pay',
    path: 'cloud-pay', // some globally-unique identifier, used internally by the router
    loadChildren: () => import('./templates/cloud-pay-template/cloud-pay-template.module').then(m => m.CloudPayTemplateModule),
  },
  {
    componentId: 'editorial',
    path: 'editorial',
    loadChildren: () => import('./templates/editorial-template/editorial-template.module').then(m => m.EditorialTemplateModule),
  },
  {
    componentId: 'calendar',
    path: 'calendar',
    loadChildren: () => import('./templates/calendar-template/calendar-template.module').then(m => m.CalendarTemplateModule),
  },
  {
    componentId: 'team',
    path: 'team',
    loadChildren: () => import('./templates/team-template/team-template.module').then(m => m.TeamTemplateModule),
  },
  {
    componentId: 'vod-player',
    path: 'vod-player',
    loadChildren: () => import('./templates/vod-player-template/vod-player-template.module').then(m => m.VodPlayerTemplateModule),
  },
  {
    componentId: 'live-player',
    path: 'live-player',
    loadChildren: () => import('./templates/live-player-template/live-player-template.module').then(m => m.LivePlayerTemplateModule),
  },
  // {
  //   componentId: 'live-multicam',
  //   path: 'live-multicam',
  //   loadChildren: () => import('./templates/multicam-player-template/multicam-player-template.module').then(m => m.MulticamPlayerTemplateModule),
  // },
  {
    componentId: 'packages',
    path: 'packages',
    loadChildren: () => import('./templates/packages-template/packages-template.module').then(m => m.PackagesTemplateModule),
  },
  {
    componentId: 'purchase',
    path: 'purchase',
    loadChildren: () => import('./templates/purchase-template/purchase-template.module').then(m => m.PurchaseTemplateModule),
  },
  {
    componentId: 'purchase-success',
    path: 'purchase-success',
    loadChildren: () => import('./templates/purchase-success-template/purchase-success-template.module').then(m => m.PurchaseSuccessTemplateModule),
  },
  {
    componentId: 'boxset',
    path: 'boxset',
    loadChildren: () => import('./templates/boxset-template/boxset-template.module').then(m => m.BoxsetTemplateModule),
  },
  {
    componentId: 'documentaries',
    path: 'documentaries',
    loadChildren: () => import('./templates/documentaries-template/documentaries-template.module').then(m => m.DocumentariesTemplateModule),
  },


  // Modules
  {
    componentId: 'carousel_vod',
    path: 'carousel_vod', // some globally-unique identifier, used internally by the router
    loadChildren: () => import('./modules/carousel-vod/carousel-vod.module').then(m => m.CarouselVodModule),
  },
  {
    componentId: 'carousel_matches',
    path: 'carousel_matches',
    loadChildren: () => import('./modules/carousel-matches/carousel-matches.module').then(m => m.CarouselMatchesModule),
  },
  {
    componentId: 'carousel_teams',
    path: 'carousel_teams',
    loadChildren: () => import('./modules/carousel-teams/carousel-teams.module').then(m => m.CarouselTeamsModule),
  },
  {
    componentId: 'spotlight_vod',
    path: 'spotlight_vod',
    loadChildren: () => import('./modules/spotlight-vod/spotlight-vod.module').then(m => m.SpotlightVodModule),
  },
  {
    componentId: 'adverts',
    path: 'adverts',
    loadChildren: () => import('./modules/adverts/adverts.module').then(m => m.AdvertsModule),
  },
  {
    componentId: 'boxset_carousel',
    path: 'boxset_carousel',
    loadChildren: () => import('./modules/boxset/boxset.module').then(m => m.BoxsetModule),
  },
  {
    componentId: 'documentaries_carousel',
    path: 'documentaries_carousel',
    loadChildren: () => import('./modules/documentaries-carousel/documentaries-carousel.module').then(m => m.DocumentariesCarouselModule),
  },
  {
    componentId: 'podcast',
    path: 'podcast',
    loadChildren: () => import('./modules/podcast/podcast.module').then(m => m.PodcastModule),
  },
];
